import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import theme from "./theme";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

ReactDOM.render(
    <BrowserRouter>
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
    </BrowserRouter>,
  document.getElementById("root")
);

serviceWorkerRegistration.register();
